import { atom } from "recoil";

export const createPartnerDrawerState = atom({
  key: "createPartnerDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
